async function fetchData(url) {
  try {
    const response = await fetch(url);
    const data = await response.text();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Function to replace content in an element with a specific ID
function replaceContent(elementId, newData) {
  const element = document.getElementById(elementId);
  let parser = new DOMParser();
  let parsedData = parser.parseFromString(newData, 'text/html');
  const renderData = parsedData.getElementById(elementId);

  if (element && renderData) {
    element.replaceWith(renderData);
  } else {
    console.error('Element with ID ' + elementId + ' not found.');
  }
}
function checkForSampleProduct() {
  // Fetch the cart
  fetch('/cart.js', { method: 'GET' })
    .then((response) => response.json())
    .then((cart) => {
      let foundSampleProduct = false;
      let idOfSamplesAdded = [];
      // Loop through the items in the cart
      for (let i = 0; i < cart.items.length; i++) {
        const product = cart.items[i];
        // Check if the product has the 'sample' tag
        if (product.product_type.includes('Complimentary')) {
          foundSampleProduct = true;
          idOfSamplesAdded.push({ id: product.id });
        }
      }
      if (foundSampleProduct) {
        if (idOfSamplesAdded.length > 1 || cart.items.length == 1) {
          //remove the free sample

          const removeButton = document.getElementById(`CartDrawer-Remove-${idOfSamplesAdded[0].id}`);
          removeButton.click();
        }
      }
    })
    .catch((error) => console.error(error));
}


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .then(function (result) {
            // let event = new Event("customCartEvent", { bubbles: true });
            // document.dispatchEvent(event);
            // let event = new Event('customCartEvent', { bubbles: true });
            // document.dispatchEvent(event);
            const urlToFetch = window.location.pathname;

            fetchData(urlToFetch).then((fetchedData) => {
              // Replace the content of the element with the fetched data
              // Replace the first argument with the ID you want to replace
              replaceContent('cart_drawer', fetchedData);
              replaceContent('cart_page', fetchedData);
            })
              .finally(() => {
                updatePrices();
              });
            checkForSampleProduct();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
